module.exports = __webpack_public_path__ + "media/assets/facebook-sign-in-7200b3cee8d6640e0b0c533f56222f00.svg";